import React from "react"

import { productUnitsSymbol } from "constant"

const StrdrmTableRow = (props) => {
  const { acceptedItem } = props

  return (
    <tr>
      <td>
        {acceptedItem.foodName}{" "}
        {acceptedItem.isSimple ? "" : acceptedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {acceptedItem.requestedQuantity}
        {productUnitsSymbol[acceptedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {acceptedItem.acceptedQuantity}{productUnitsSymbol[acceptedItem.unit]}
      </td>
    </tr>
  )
}

export default React.memo(StrdrmTableRow)